/* eslint-disable */
export default {
  forward: 'Lähetä edelleen',
  ignore: 'Ohita',
  toVoicemail: 'Vastaajaan',
  answer: 'Vastaa',
  endAndAnswer: 'Lopeta ja vastaa',
  holdAndAnswer: 'Aseta pitoon ja vastaa',
  custom: 'Mukautettu',
  more: 'Lisää',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
